import { useMemo } from "react";

import { type ResourceContainer } from "../../gql-generated/types";
import { useDefaultOrganizationContainerV2, useOrganizationsV2Data } from "../../shared/hooks/useOrganizationsV2";
import { type KeyedOption } from "../../shared/models";
import { sortOrganizationsAvailableForLensSpaceCreation } from "../components/lens-space";

interface UseOrganizationOptionsV2Props {
    organizations?: readonly ResourceContainer[];
}

export const useOrganizationOptionsV2 = ({
    organizations: providedOrganizations,
}: UseOrganizationOptionsV2Props = {}): KeyedOption[] => {
    const organizationsFromState = useOrganizationsV2Data();
    const defaultOrganizationContainer = useDefaultOrganizationContainerV2();

    const organizations = providedOrganizations ?? organizationsFromState;

    return useMemo(() => {
        if (organizations.length === 0) return [];
        const sortedOrganizations = sortOrganizationsAvailableForLensSpaceCreation(
            organizations,
            defaultOrganizationContainer?.id ?? "",
        );
        return sortedOrganizations.map((organization) => ({
            key: organization.id,
            value: organization.id,
            label: organization.name,
        }));
    }, [organizations, defaultOrganizationContainer?.id]);
};
